<template>
  <div id="menu-container">
    <template v-for="menu in menus" v-if="filterMenu(menu)">
      <div :key="menu.id" style="text-align: center;" v-if="thumb === 1">
        <i :class="menu.icon ? menu.icon + ' thumb' : 'iconmenu el-icon-menu-default thumb'"></i>
      </div>
      <div :key="menu.id" class="item" v-if="thumb !== 1">
        <div class="m1" :id="'menu_' + menu.id" @click="jump(menu)">
          <i :class="menu.icon || 'iconmenu el-icon-menu-default'"></i> {{ menu.name }}
          <span></span>
        </div>
        <nav-menu-item :parent="menu" :menus="menus" @setMenu="jump"/>
      </div>
    </template>
  </div>
</template>

<script>
  import * as config from '../../core/config'

  export default {
    name: 'NavMenu',
    props: {
      menus: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
      }
    },
    computed: {
      thumb: function () {
        return this.$store.state.session.thumb
      }
    },
    watch: {
      menus: {
        immediate: true,
        handler (nv) {
          if (config.layout !== 1 && this.menus.length > 0) {
            this.jump(this.menus[0])
          }
        }
      }
    },
    methods: {
      filterMenu (menu) {
        if (config.layout !== 1 && menu.pid === '-1') {
          return true
        } else {
          if (menu.pid === this.$store.state.session.module.id) {
            return true
          }
        }
        return false
      },
      jump (menu) {
        // 告知当前模块被切换
        this.$emit('setMenu', menu)
      }
    }
  }
</script>
